import axios from 'axios'
import appConfig from '@src/app.config'


export const state = {
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { email, password } = {}) {


    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(appConfig.api+'users/login/', { email:email, password:password })
      .then((response) =>
      {

        if(response.data)
        {
          if(response.data.status == false)
          {
              throw response.data;
          }
          else{

            const user = response.data;
            delete user.code;
            delete user.status;

            commit('SET_CURRENT_USER', user)
            return false;

          }
        }
        else{
          throw {status:false,error_message:['Network error, Please try again later.']};
        }
      }).catch((error) => {
        if(error.code !== undefined){
            throw error;
        }
        else{
            throw {status:false,error_message:['Network error, Please try again later.']};
        }

      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    localStorage.removeItem('auth.currentUser');
    commit('SET_CURRENT_USER', null);
  },

  /*
  // register the user
  register({ commit, dispatch, getters }, { fullname, email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/register', { fullname, email, password })
      .then((response) => {
        const user = response.data
        return user
      })
  },

  // register the user
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios.post('/api/reset', { email }).then((response) => {
      const message = response.data
      return message
    })
  },
  */

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state })
  {
    if (!state.currentUser) return Promise.resolve(null)

    return axios
      .post(appConfig.api+'users/validate_token/', state.currentUser)
      .then((response) =>
      {
        if(response.data)
        {
          if(response.data.status == false)
          {
              throw response.data;
          }
          else
          {
            const user = response.data;
            delete user.code;
            delete user.status;

            commit('SET_CURRENT_USER', user);
            return user
          }
        }
        else
        {
          throw {status:false,error_message:['Network error, Please try again later.']};
        }
      })
      .catch((error) =>
      {
        commit('SET_CURRENT_USER', null);
        localStorage.removeItem('auth.currentUser');
        return null;
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {

}
